import { render, staticRenderFns } from "./PropertyRestrictToShareYN.vue?vue&type=template&id=4f1dc7d8"
import script from "./PropertyRestrictToShareYN.vue?vue&type=script&lang=js"
export * from "./PropertyRestrictToShareYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports